module.exports = __webpack_public_path__ + "img/7.1101dd97.jpg";